import { render, staticRenderFns } from "./ChooseMultipleProductInput.vue?vue&type=template&id=cef96a54&scoped=true"
import script from "./ChooseMultipleProductInput.vue?vue&type=script&lang=js"
export * from "./ChooseMultipleProductInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef96a54",
  null
  
)

export default component.exports